// extracted by css-extract-rspack-plugin
export default {"file-metadata":"xfPX_P","fileMetadata":"xfPX_P"};